var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:`icon-text-button ${_vm.customClass}`,on:{"click":function($event){return _vm.$emit('button:clicked')}}},[_c(_vm.button,{tag:"component"}),_c('span',[_vm._v(_vm._s(_vm.text))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }